export const AD_STATUS = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    ARCHIVED: 'ARCHIVED',
    TERMINATED: 'TERMINATED',
};
